export default {
      id: "settings-icon-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "sprite.svg#settings-icon",
      toString: function () {
        return this.url;
      }
    }